var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvBackLeft01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 287,
    viewBox: "0 0 224 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3683 160.546L75.8686 160.998C83.8037 168.158 96.0701 167.559 103.266 159.664L218.973 32.7148C226.169 24.8194 225.567 12.6144 217.632 5.45421L217.131 5.00174C209.196 -2.15842 196.93 -1.55891 189.734 6.3365L74.0269 133.285C66.8307 141.181 67.4333 153.386 75.3683 160.546Z",
    fill: "url(#paint0_linear_685_5648)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.015 234.438C30.6373 235.816 28.4003 235.816 27.0151 234.438C25.6299 233.061 25.6373 230.824 27.0151 229.438C28.3929 228.053 30.6299 228.061 32.015 229.438C33.4002 230.816 33.3928 233.053 32.015 234.438Z",
    fill: "#C7CFE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 247.209C43.4079 248.587 41.1709 248.587 39.7858 247.209C38.408 245.831 38.408 243.594 39.7858 242.209C41.1635 240.824 43.4005 240.831 44.7857 242.209C46.1635 243.587 46.1635 245.824 44.7857 247.209Z",
    fill: "#C7CFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5562 259.971C56.1784 261.349 53.9414 261.349 52.5563 259.971C51.1785 258.593 51.1785 256.356 52.5563 254.971C53.934 253.586 56.171 253.593 57.5562 254.971C58.9414 256.349 58.934 258.586 57.5562 259.971Z",
    fill: "#C7CFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.015 234.438C30.6373 235.816 28.4003 235.816 27.0151 234.438C25.6299 233.061 25.6373 230.824 27.0151 229.438C28.3929 228.053 30.6299 228.061 32.015 229.438C33.4002 230.816 33.3928 233.053 32.015 234.438Z",
    fill: "#C7CFE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 247.209C43.4079 248.587 41.1709 248.587 39.7858 247.209C38.408 245.831 38.408 243.594 39.7858 242.209C41.1635 240.824 43.4005 240.831 44.7857 242.209C46.1635 243.587 46.1635 245.824 44.7857 247.209Z",
    fill: "#C7CFE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5562 259.971C56.1784 261.349 53.9414 261.349 52.5563 259.971C51.1785 258.593 51.1785 256.356 52.5563 254.971C53.934 253.586 56.171 253.593 57.5562 254.971C58.9414 256.349 58.934 258.586 57.5562 259.971Z",
    fill: "#C7CFE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.015 259.971C30.6373 261.349 28.4003 261.349 27.0151 259.971C25.6299 258.593 25.6373 256.356 27.0151 254.971C28.3929 253.586 30.6299 253.593 32.015 254.971C33.3928 256.349 33.3928 258.586 32.015 259.971Z",
    fill: "#C7CFE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 272.742C43.4079 274.12 41.1709 274.12 39.7858 272.742C38.408 271.364 38.408 269.127 39.7858 267.742C41.1635 266.365 43.4005 266.365 44.7857 267.742C46.1635 269.12 46.1635 271.357 44.7857 272.742Z",
    fill: "#C7CFE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.015 259.971C30.6373 261.349 28.4003 261.349 27.0151 259.971C25.6299 258.593 25.6373 256.356 27.0151 254.971C28.3929 253.586 30.6299 253.593 32.015 254.971C33.3928 256.349 33.3928 258.586 32.015 259.971Z",
    fill: "#C7CFE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7857 272.742C43.4079 274.12 41.1709 274.12 39.7858 272.742C38.408 271.364 38.408 269.127 39.7858 267.742C41.1635 266.365 43.4005 266.365 44.7857 267.742C46.1635 269.12 46.1635 271.357 44.7857 272.742Z",
    fill: "#C7CFE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2455 272.742C17.8677 274.12 15.6307 274.12 14.2456 272.742C12.8604 271.364 12.8678 269.127 14.2456 267.742C15.6233 266.365 17.8603 266.365 19.2455 267.742C20.6307 269.12 20.6233 271.357 19.2455 272.742Z",
    fill: "#C7CFE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0152 285.512C30.6374 286.89 28.4004 286.89 27.0153 285.512C25.6375 284.134 25.6375 281.897 27.0153 280.512C28.393 279.135 30.63 279.135 32.0152 280.512C33.4004 281.89 33.3929 284.127 32.0152 285.512Z",
    fill: "#C7CFE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2455 272.742C17.8677 274.12 15.6307 274.12 14.2456 272.742C12.8604 271.364 12.8678 269.127 14.2456 267.742C15.6233 266.365 17.8603 266.365 19.2455 267.742C20.6307 269.12 20.6233 271.357 19.2455 272.742Z",
    fill: "#C7CFE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0152 285.512C30.6374 286.89 28.4004 286.89 27.0153 285.512C25.6375 284.134 25.6375 281.897 27.0153 280.512C28.393 279.135 30.63 279.135 32.0152 280.512C33.4004 281.89 33.3929 284.127 32.0152 285.512Z",
    fill: "#C7CFE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2457 247.209C12.868 245.831 12.868 243.594 14.2457 242.209C15.6235 240.831 17.8605 240.831 19.2457 242.209C20.6234 243.586 20.6234 245.823 19.2457 247.209C17.8679 248.586 15.6309 248.586 14.2457 247.209Z",
    fill: "#C7CFE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47521 259.972C0.0974546 258.594 0.0974546 256.357 1.47521 254.972C2.85297 253.594 5.08998 253.594 6.47515 254.972C7.86032 256.35 7.85291 258.587 6.47515 259.972C5.09739 261.349 2.86038 261.349 1.47521 259.972Z",
    fill: "#C7CFE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 76.3203C101.881 76.3203 103 74.9772 103 73.3203C103 71.6635 101.881 70.3203 100.5 70.3203C99.1193 70.3203 98 71.6635 98 73.3203C98 74.9772 99.1193 76.3203 100.5 76.3203Z",
    fill: "url(#paint1_linear_685_5648)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 194C159.119 194 158 195.119 158 196.5C158 197.881 159.119 199 160.5 199C161.88 199 163 197.881 163 196.5C163 195.119 161.88 194 160.5 194Z",
    fill: "#C7CFE4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114 230C111.79 230 110 231.791 110 234C110 236.209 111.79 238 114 238C116.209 238 118 236.209 118 234C118 231.791 116.209 230 114 230Z",
    fill: "#C7CFE4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 87.3203C202.881 87.3203 204 86.201 204 84.8203C204 83.4396 202.881 82.3203 201.5 82.3203C200.119 82.3203 199 83.4396 199 84.8203C199 86.201 200.119 87.3203 201.5 87.3203Z",
    fill: "#C7CFE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_5648",
    x1: 92.4209,
    y1: 66.6581,
    x2: 200.493,
    y2: 99.6581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB683"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_685_5648",
    x1: 98,
    y1: 73.3203,
    x2: 103,
    y2: 73.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C44A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvBackLeft01);
export default __webpack_public_path__ + "static/media/fv-back__left01.b9e62c1b4569519d6e8ddc31a450725a.svg";
export { ForwardRef as ReactComponent };